<div class="init-body">
    <mat-toolbar color="primary">
        <span class="left-content">SpendWyze Payment Request Customer Dashboard</span>
        <span class="fill-space"></span>
        <span class="right-content">
            <span>Kijelentkezés ennyi idő múlva:&nbsp;</span><app-timer></app-timer>
            <button mat-icon-button (click)="logout()">
                <mat-icon>logout</mat-icon>
            </button>
        </span>
    </mat-toolbar>

    <div class="init-container">
        <mat-card>
            <mat-tab-group animationDuration="0ms">
                <mat-tab label="Fizetési kérelem küldés">
                    <mat-card-content class="init-card-content">

                        <mat-radio-group aria-label="Payment Request Mode" #modeSelector="matRadioGroup">
                            <mat-radio-button value="UNATTENDED" [checked]="true">Fizető fél részvétele nélkül</mat-radio-button>
                            <mat-radio-button value="PAYER_ATTENDED">Fizető fél részvételével</mat-radio-button>
                        </mat-radio-group>

                        <app-init-unattended *ngIf="modeSelector.value === 'UNATTENDED'"></app-init-unattended>
                        <app-init-payer-attended
                            *ngIf="modeSelector.value === 'PAYER_ATTENDED'"></app-init-payer-attended>

                    </mat-card-content>
                </mat-tab>
                <mat-tab label="Kiküldött fizetési kérelmek listája">
                    <mat-card-content class="init-card-content">
                        <app-payment-request-list></app-payment-request-list>
                    </mat-card-content>
                </mat-tab>
                <mat-tab label="Számlázás riport">
                    <mat-card-content class="init-card-content">
                        <app-billing-report></app-billing-report>
                    </mat-card-content>
                </mat-tab>
            </mat-tab-group>
        </mat-card>
    </div>
</div>